import { debounce } from "@sazka/utils/debounce";
import { FlickityPatched } from "@sazka/utils/carousel/flickity-patched";
import { documentReady } from "@sazka/utils/document-ready";

const onImagesLoaded = (container, callback) => {
    const images = container.querySelectorAll("img");
    let imagesCount = images.length;

    if (!imagesCount) {
        callback();
        return;
    }

    images.forEach((el) => {
        if (el.complete) {
            imagesCount--;
            if (imagesCount === 0) {
                callback();
            }
            return;
        }

        el.onload = () => {
            imagesCount--;
            if (imagesCount === 0) {
                callback();
            }
        };
    });
};

documentReady(() => {
    const roots = document.querySelectorAll(".lp-cards-img-carousel");
    if (!roots.length) {
        return;
    }

    roots.forEach((el) => {
        const root = el;
        let flickity = null;
        const cardsCount = root.querySelectorAll(".lp-card-img-carousel").length;
        let slidesCount = 2;

        serviceFlickity();

        const resizeHandler = debounce(function () {
            serviceFlickity();
        }, 100);

        window.addEventListener("resize", resizeHandler);
        onImagesLoaded(root, serviceFlickity);

        function initFlickity() {
            flickity = new FlickityPatched(root.querySelector(".lp-cards-img-carousel__container"), {
                prevNextButtons: false,
                autoPlay: false,
                pageDots: false,
                contain: true,
                groupCells: true,
                cellAlign: "left",
            });
        }

        function disableButtons() {
            const previousButton = root.querySelector(".flickity-button__wrapper.previous");
            const nextButton = root.querySelector(".flickity-button__wrapper.next");

            if (flickity.selectedIndex > 0) {
                previousButton.classList.remove("disabled");
            } else {
                previousButton.classList.add("disabled");
            }

            if (flickity.selectedIndex >= slidesCount - 1) {
                nextButton.classList.add("disabled");
            } else {
                nextButton.classList.remove("disabled");
            }
        }

        function initButtons() {
            const previousButton = root.querySelector(".flickity-button.previous");
            const nextButton = root.querySelector(".flickity-button.next");

            // previous
            previousButton.addEventListener("click", function () {
                flickity.previous();
                if (flickity.selectedIndex < slidesCount - 1) {
                    nextButton.parentElement.classList.remove("disabled");
                }
                if (flickity.selectedIndex <= 0) {
                    previousButton.parentElement.classList.add("disabled");
                }
            });

            // next
            nextButton.addEventListener("click", function () {
                flickity.next();
                if (flickity.selectedIndex > 0) {
                    previousButton.parentElement.classList.remove("disabled");
                }
                if (flickity.selectedIndex >= slidesCount - 1) {
                    nextButton.parentElement.classList.add("disabled");
                }
            });

            flickity.on("select", function () {
                slidesCount = flickity.slides.length;
                disableButtons();
            });
        }

        function serviceFlickity() {
            const mediaQueryMax = window.matchMedia("(max-width: 897px)").matches;
            const mediaQueryMin = window.matchMedia("(min-width: 897px)").matches;

            const cards = root.querySelectorAll(".lp-card-img-carousel") as NodeListOf<HTMLElement>;

            if ((!flickity && mediaQueryMax) || (!flickity && cardsCount > 3)) {
                initFlickity();
                initButtons();
                cards.forEach((el) => el.classList.add("is-equal"));
            } else if ((!flickity?.isActive && mediaQueryMax) || (!flickity?.isActive && cardsCount > 3)) {
                flickity._create();
                initButtons();
            } else if (mediaQueryMin && flickity?.isActive && cardsCount <= 3) {
                try {
                    flickity.destroy();
                    root.querySelectorAll(".flickity-button").forEach((btn) =>
                        btn.parentElement.classList.toggle("has-buttons")
                    );
                } catch (e) {}
            }

            if (flickity?.isActive) {
                cards.forEach((el) => {
                    el.style.height = "auto";
                });
                flickity.resize();
                cards.forEach((el) => {
                    el.style.height = "100%";
                });
            } else {
                cards.forEach((el) => {
                    el.style.height = "";
                });
            }
        }
    });
});
